import { TransportEnum, TransportType } from "@/types/graphql";

const TRANSPORT_LABELS: Record<TransportEnum, string> = {
  [TransportEnum.Email]: "email",
  [TransportEnum.Sms]: "phone",
};

export const composeTransportLabels = (
  transports: Array<TransportType> = []
): string | undefined => {
  return transports.length > 0
    ? transports
        .map(
          (transport) => TRANSPORT_LABELS[transport.transport as TransportEnum]
        )
        .join(" and ")
    : undefined;
};

export const composeTransportRecipients = (
  transports: Array<TransportType> = []
): string | undefined => {
  return transports.length > 0
    ? transports.map((transport) => transport.recipient).join(" and ")
    : undefined;
};
